module.exports = __webpack_public_path__ + "static/media/thinkcentre.01c06b98.jpg";